import React, { useEffect } from 'react'


export const FCC = ({tplHTML,fccLabel,IsNYDMA})=>{
    const [tphtm,setTPHtm] = React.useState(null)
    useEffect(()=>{
        if(tplHTML && tplHTML != "" && fccLabel!==null&&fccLabel&&fccLabel.length ){
            const parsedFccLabel = JSON.parse(fccLabel)
            let resValues = parsedFccLabel[0];
            if(parsedFccLabel && parsedFccLabel.length) resValues = parsedFccLabel[parsedFccLabel.length - 1];
            if(resValues){
                var resKeys = Object.keys(resValues);
                if(resKeys && Array.isArray(resKeys)){
                    resKeys.map((resKey)=>{
                        var keyReg = new RegExp(resKey,'g');
                        if(Array.isArray(resValues[resKey])){
                            var tplHTMLArr = "";
                            resValues[resKey].map((labVal)=>{
                                if(labVal && labVal.label && labVal.value && ((resKey === "_fcc_providerMthyFee_" && labVal.isNY && labVal.isNY === 'Y' && IsNYDMA) || resKey !== "_fcc_providerMthyFee_")){
                                    tplHTMLArr += '<div class="fl-col9"><p>'+ labVal.label  +'</p></div><div class="fl-col3"><p class="txt-rt fwt-bd fcc-val">'+ labVal.value  +'</p></div>';
                                }
                            });
                            tplHTML = String(tplHTML).replace(keyReg, tplHTMLArr);
                        } else if(resValues[resKey] != "_DY_"){
                            tplHTML = String(tplHTML).replace(keyReg, (resValues[resKey] ? resValues[resKey] : ""));
                        }
                    });
                    // const resultFile = parse(tplHTML)
                    setTPHtm(tplHTML)
                }
            }
}     
    },[fccLabel,tplHTML])
   
    if(tphtm !== null && tphtm && tphtm !== 'undefined'){
    return(
        <div className={`fcc-plan`} onClick={e=>e.preventDefault()}>
            <div dangerouslySetInnerHTML={{__html:tphtm}}></div>
        </div>
    )
    }else return <></> 
}